import * as React from 'react'
import styled from '../theme/styled'
import images from '../images'
import { IModalDivInternalProps } from '../types/index'
import { StyledComponentClass } from 'styled-components'
import { KeravaRadarButton } from '../elements/button'

const Wrapper = styled.div`
color: ${({ theme }) => `${theme.color.textDark}`};
text-decoration: none;
transition: all 0.2s;
&:hover {
color: ${({ theme }) => `${theme.color.textLight}`};
color: textLight;
}
`
const About = styled.div`
cursor: pointer;
font-size: inherit;
`

const Modal: StyledComponentClass<IModalDivInternalProps, any> = styled<IModalDivInternalProps, 'div'>('div')`
display: ${({ visible }) => visible ? 'block' : 'none'};
position: fixed; /* Stay in place */
z-index: 1; /* Sit on top */
padding-top: 100px; /* Location of the box */
left: 0;
top: 0;
width: 100%; /* Full width */
height: 100%; /* Full height */
overflow: auto; /* Enable scroll if needed */
background-color: rgb(0,0,0); /* Fallback color */
background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
transition: all 0.5s;
`

const Content = styled.div`
background-color: ${({ theme }) => `${theme.color.white}`};
margin: auto;
display: flex;
flex-direction: row;
flex-wrap: wrap;
padding: 20px;
border: 1px solid ${({ theme }) => `${theme.color.primaryDarker}`};
border-radius: 0.30em;
width: 80%;
margin-bottom: 100px;
text-transform: none;
@media (max-width: ${({ theme }) => `${theme.breakpoint.modalLarge}`}) {
  flex-direction: column;
}
color: ${({ theme }) => theme.color.textDark}
`

const Sticky = styled.div`
@media (max-width: ${({ theme }) => `${theme.breakpoint.small}`}) {
  position: fixed;
  display: block;
  margin-left: auto;
  margin-right: auto;
  bottom: 0;
}
`

const TopDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width:50%;
  @media (max-width: ${({ theme }) => `${theme.breakpoint.modalLarge}`}) {
    width:100%;
  }
  @media (max-width: ${({ theme }) => `${theme.breakpoint.small}`}) {
  flex-direction: column;
  }
`

const BottomDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width:50%;
  margin-bottom: 40px;
  @media (max-width: ${({ theme }) => `${theme.breakpoint.modalLarge}`}) {
    width:100%;
  }
`

const TopText = styled.div`
  flex-grow: 1;
  margin: 0px 40px;
  width:50%;
  @media (max-width: ${({ theme }) => `${theme.breakpoint.small}`}) {
    width:100%;
    margin: 0px;
}
`
const KeravaImage = styled.img`
max-width: 100%;
height: auto;
@media (max-width: ${({ theme }) => `${theme.breakpoint.small}`}) {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
`

const RadarImage = styled.img`
  max-width: 100%;
  height: auto;
  @media (max-width: ${({ theme }) => `${theme.breakpoint.modalLarge}`}) {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
  }
`

class KeravaRadarInfo extends React.PureComponent {
  state = {
    visible: false,
    location: 'http://maps.google.com/maps' +
      '?f=q&source=s_q&hl=en&geocode=&q=%4060.388099,25.113428&sll=60.388093,25.113673&sspn=0.016498,0.055661&ie=UTF8&z=16'
  }

  public openModal = (e: React.MouseEvent): void => {
    this.setState({
      visible: true
    })
  }

  public closeModal = (e: React.MouseEvent): void => {
    this.setState({
      visible: false
    })
  }

  public render() {
    return (
      <Wrapper>
        <About onClick={this.openModal}>About</About>
        <Modal {...{ visible: this.state.visible }}>
          <Content>
            <TopDiv>
              <div>
                <KeravaImage src={images.keravaRadar} alt="Kerava radar" />
              </div>
              <TopText>
                <h1>Kerava weather radar</h1>
                <p>On top of the Kerava water tower is a Vaisala Weather Radar,
                which has been operational since August 2008. The radar is built purely for
                testing purposes and the data from the radar is made available for
                public use whenever the radar is in use. Please note that there might be
                breaks in the service for this purpose and the data is not
                always shown in real time.
            </p>
                <p>Note also that the type observations are made at heights
              increasing as function of range as shown in the diagram.</p>
              </TopText>
            </TopDiv>
            <BottomDiv>
              <div>
                <RadarImage src={images.radarObservationHeight} alt="Radar observation height" />
              </div>

              <p>
                The Vaisala Weather Radar is a magnetron type dual
                polarization radar.
                What makes the Vaisala Weather Radar special is its ability
                to distinguish between variations in the types of precipitation:
                it can accurately identify
                rain, snow, sleet, hail and graupel, and even filter out
                reflectivities from non-meteorological targets. This makes
                it ideal for applications such
                as severe weather monitoring, improved precipitation
                forecasting, hydrometeorological applications e.g. flood
                forecasting, hail detection and
                hurricane/typhoon/cyclone tracking among many others.
            </p>

              <p>See <a href=
                {this.state.location}>
                the location of the radar
              </a> on the map.
            </p>
            </BottomDiv>
            <Sticky>
              <KeravaRadarButton width="100px" onClick={this.closeModal}>
                close
            </KeravaRadarButton>
            </Sticky>
          </Content>
        </Modal>
      </Wrapper>
    )
  }
}

export default KeravaRadarInfo



// WEBPACK FOOTER //
// ./src/components/KeravaRadarInfo.tsx